export const WELCOME_SEEN_KEY = 'rubikoo-welcome-seen-v1';

export function hasSeenWelcome(): boolean {
  try {
    return localStorage.getItem(WELCOME_SEEN_KEY) === 'true';
  } catch {
    // Optional onboarding must not block entry when device storage is unavailable.
    return true;
  }
}

export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(WELCOME_SEEN_KEY, 'true');
  } catch {
    // Navigation remains available even when persistence is unavailable.
  }
}
